import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, useTranslation } from '@pascal/pascal-core';
import { liveBetsDataStore } from '../../store/liveBetsDataStore';

export const LiveBets = observer(() => {
  const { liveBets } = liveBetsDataStore;
  const t = useTranslation();

  return (
    <div className='turbo-poker-right-side-min-container'>
      <input type='checkbox' id='winning-table-trigger' className='checkbox-tb' />
      <div className='turbo-poker-right-side-min-container-inner'>
        <div className='right-side-min-container-inner-header'>
          <div className='right-side-min-container-inner-header-row'>
            <p className=' right-side-min-container-header-row-titles'>{t('USER')}</p>
            <p className='right-side-min-container-header-row-titles'>{t('BET')}</p>
            <p className='right-side-min-container-header-row-titles'>{t('ODD')}</p>
            <p className='right-side-min-container-header-row-titles'>{t('WIN')}</p>
          </div>
        </div>
        <div className='turbo-poker-right-side-container-for-scroll'>
          <div className='scrollable-container'>
            <div className='t-b-for-scroll-padding'>
              {liveBets.map(({ userId, amount, winAmount, id, odd }) => (
                <div className='right-side-scrollable-container-rows' key={id}>
                  <p className='right-side-scrollable-container-values'>id: {userId}</p>
                  <p className='right-side-scrollable-container-values'>{convertAmount(amount)}</p>
                  <p className='right-side-scrollable-container-values'>x{odd}</p>
                  <p className='right-side-scrollable-container-values'>
                    {convertAmount(winAmount)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        htmlFor='winning-table-trigger'
        className='winning-table-toggle'
        data-more-label={t('SHOW_MORE')}
        data-less-label={t('SHOW_LESS')}
      >
        <i className='winning-table-toggle-arrow icon-arrow-up' />
      </label>
    </div>
  );
});
